import './scss/index.scss';
import { dcFactory } from 'dc';
import NotificationsComponent from './js/notifications.component';

dcFactory.register(NotificationsComponent);
